import User from "@mapmycustomers/shared/types/User";

const getTeamNames = (user: User) => user.teams.map(({ name }) => name).join(", ");

export default getTeamNames;
